import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'
import { isThinRegistrationBaseOutput, ThinRegistrationBaseOutput } from './thin-registration-base-output.model'

export interface CheckPhoneOutput extends ThinRegistrationBaseOutput, BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  IsOTPGenerated: boolean
  OTPRequestBlockedUntil: string
  OTPRequestRemaining: number
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isCheckPhoneOutput = (obj: any): obj is CheckPhoneOutput => {
  const isOTPGenerated = 'IsOTPGenerated'
  const otpRequestBlockedUntil = 'OTPRequestBlockedUntil'
  const otpRequestRemaining = 'OTPRequestRemaining'

  return (
    isThinRegistrationBaseOutput &&
    isBaseOutput(obj) &&
    has(obj, isOTPGenerated) &&
    has(obj, otpRequestBlockedUntil) &&
    has(obj, otpRequestRemaining)
  )
}
